export default __webpack_public_path__ + "static/media/icon-hamburger-main-menu.48cbaffe.svg";